import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { FixedFeeAvailableConfigsQuery } from '../../../../../../store/fixedFee/selector';
import { FixedFeeAvailableConfigs } from '../../../../../../store/fixedFee/types';

interface UseStepOneAvailableConfigsProps {
  advisorId: number;
  partnerId: number;
}

interface UseStepOneAvailableConfigsResult {
  availableConfigs?: FixedFeeAvailableConfigs;
  loadingAvailableRateRanges: boolean;
}

export const useStepOneAvailableConfigs = ({
  advisorId,
  partnerId,
}: UseStepOneAvailableConfigsProps): UseStepOneAvailableConfigsResult => {
  const { data, loading } = useRecoilQuery(
    FixedFeeAvailableConfigsQuery({
      advisorId,
      partnerId,
    })
  );

  return {
    availableConfigs: data?.data,
    loadingAvailableRateRanges: loading,
  };
};
